import http from "../http";

export default {
  /* 旧版-获取历史列表 */
  // getHistoryList(params) {
  //   return http.get(`/order/history`, params, {
  //     loading: true,
  //   });
  // },

  /* 新版江文改动-获取历史列表 */
  getHistoryList(params) {
    return http.get(`order/history/list`, params, {
      loading: true,
    });
  },
}